import { render, staticRenderFns } from "./InsLogoGather.vue?vue&type=template&id=95779dd2&scoped=true"
import script from "./InsLogoGather.vue?vue&type=script&lang=ts"
export * from "./InsLogoGather.vue?vue&type=script&lang=ts"
import style0 from "./InsLogoGather.vue?vue&type=style&index=0&id=95779dd2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95779dd2",
  null
  
)

export default component.exports